import { sortingList } from '../../../utils/helper'
import { DataItem } from './types'

export const sortingActivityList = (
  list: DataItem[],
  type: string,
  name: string | undefined
): DataItem[] => {
  try {
    let newList: DataItem[] = list
    switch (name) {
      case 'CheckNumber':
        newList = sortingList(list, type, name, 'number')
        break
      case 'CheckedDate':
        newList = sortingList(list, type, name, 'date')
        break
      default:
        newList = sortingList(list, type, name || '', 'string')
    }

    return newList
  } catch (e) {
    return list
  }
}
